export default function CalendarController($scope, Calendar, Restangular, notification, $stateParams, $locale, $location, $window) {

        // TODO: request centerId from session factory
        $scope.centerId = $window.localStorage.getItem('center_id');

        // FIXME
        var Group = {query: function() {
            return Restangular.all('groups').getList().$object;
        }};
        var loading = {
                start: function(str) {
                    notification.log(str);
                },
                stop: function() {
                    notification.remove();
                }
        };

        function dateToString(date){
            function twoDigitNumberString(number) {
                var result = number.toString();
                if(result.length < 2) {
                    result = '0' + result;
                }
                return result;
            }

            return '' +
                date.getFullYear() + '-' +
                twoDigitNumberString(date.getMonth() + 1) + '-' +
                twoDigitNumberString(date.getDate());
        }

        function loadMonth (year, month) {

            function getFirstDayOfWeekOfMonth (year, month) {
                var offset = [-5, 1, 0, -1, -2, -3, -4],
                    firstDayOfMonth = new Date(year, month, 1),
                    firstDayOfFirstWeekOfMonth =
                        new Date(
                            firstDayOfMonth.getFullYear(),
                            firstDayOfMonth.getMonth(),
                            offset[firstDayOfMonth.getDay()]
                        );

                return firstDayOfFirstWeekOfMonth;
            }

            function getLastDayOfWeekOfLastMonth (year, month) {
                var offset = [0, 6, 5, 4, 3, 2, 1],
                    lastDayOfMonth = new Date(year, month+1, 0),
                    lastDayOfLastWeekOfMonth =
                        new Date(
                            lastDayOfMonth.getFullYear(),
                            lastDayOfMonth.getMonth()+1,
                            offset[lastDayOfMonth.getDay()]
                        );
                return lastDayOfLastWeekOfMonth;
            }

            var from = getFirstDayOfWeekOfMonth(year, month);
            var to = getLastDayOfWeekOfLastMonth(year, month);

            $scope.from = dateToString(from);
            $scope.to = dateToString(to);

            Calendar.get($scope.centerId, $scope.from, $scope.to)
                .success(function(days){
                    $scope.days = days;
                });
        }


        function loadWeek(year, month, day) {
            function getFirstDayOfWeek() {
                var daysOfWeek = [6,0,1,2,3,4,5];
                var date = new Date(year, month, day);
                var offset = daysOfWeek[date.getDay()];
                date.setDate(date.getDate() - offset);
                return date;
            }

            function getLastDayOfWeek() {
                var daysOfWeek = [0,6,5,4,3,2,1];
                var date = new Date(year, month, day);
                var offset = daysOfWeek[date.getDay()];
                date.setDate(date.getDate() + offset);
                return date;
            }

            $scope.from = dateToString(getFirstDayOfWeek());
            $scope.to = dateToString(getLastDayOfWeek());
            Calendar.get($scope.centerId, $scope.from, $scope.to)
                .success(function(days){
                    $scope.days = days;
                });
        }

        function updateView() {
            if($scope.viewMode === 'month'){
                loadMonth($scope.year, $scope.month);
            }else{
                loadWeek($scope.year, $scope.month, $scope.day);
            }
            $location.search('date', [$scope.year, $scope.month + 1, $scope.day].join('-'));
            $location.search('view', $scope.viewMode);
        }

        $scope.next = function () {

            function nextMonth(){
                if($scope.month < 11){
                    $scope.month++;
                }else{
                    $scope.month = 0;
                    $scope.year++;
                }
            }

            function nextWeek() {
                var date = new Date($scope.year, $scope.month, $scope.day + 7);
                $scope.year = date.getFullYear();
                $scope.month = date.getMonth();
                $scope.day = date.getDate();
            }

            if($scope.viewMode === 'month'){
                nextMonth();
            }else{
                nextWeek();
            }

            updateView();
        }

        $scope.prev = function () {

            function prevMonth () {
                if($scope.month > 0){
                    $scope.month--;
                }else{
                    $scope.month = 11;
                    $scope.year--;
                }
            }

            function prevWeek () {
                var date = new Date($scope.year, $scope.month, $scope.day - 7);
                $scope.year = date.getFullYear();
                $scope.month = date.getMonth();
                $scope.day = date.getDate();
            }

            if($scope.viewMode === 'month'){
                prevMonth();
            }else{
                prevWeek();
            }
            updateView();
        }

        $scope.showWeek = function(){
            function isShownCurrentMonth(){
                var today = new Date();
                return $scope.month === today.getMonth() &&
                    $scope.year === today.getFullYear();
            }
            if(isShownCurrentMonth()){
                $scope.day = new Date().getDate();
            }else{
                $scope.day = 1;
            }
            $scope.viewMode = 'week';

            updateView();
        };

        $scope.showMonth = function () {
            $scope.viewMode = 'month';
            updateView();
        }

        var today = new Date(),
            markDate = $stateParams.date ? new Date($stateParams.date) : new Date();
        $scope.day = markDate.getDate();
        $scope.month = markDate.getMonth();
        $scope.year = markDate.getFullYear();
        $scope.today = dateToString(today);
        $scope.groups = Group.query();
        $scope.$locale = $locale;
        $scope.viewMode = $stateParams.view === 'month' ? 'month' : 'week';
        updateView();

        $scope.getDateUsingMonth = function(){
            return new Date($scope.year, $scope.month);
        };

        $scope.print = function(centerId, from, to) {
            // FIXME: translate
            loading.start('Generando pdf...');
            Calendar
                .print(
                        $scope.centerId,
                        from || $scope.from,
                        to || $scope.to
                    )
                    .then(function(response) {
                        var link = document.querySelector('#pdfLink');
                        link.href = URL.createObjectURL(response.data);
                        link.download = $scope.from + '_' + $scope.to + '.pdf';
                        document.body.appendChild(link);
                        link.click();
                    })
                    .finally(function(){
                        loading.stop();
                    });
        };

        $scope.generate = function(centerId, from, to, group_id) {
            // FIXME: translate
            loading.start('Generando planificación...');
            var group_ids = $scope.groups.map(function(group){
                return group.id;
            });
            Calendar
                .generate(
                        $scope.centerId,
                        from || $scope.from,
                        to || $scope.to,
                        group_id ? [group_id] : group_ids)
                    .then(function(){
                        updateView();
                    })
                    .finally(function(){
                        loading.stop();
                    })
        }

}

CalendarController.$inject = [
     '$scope', 'Calendar', 'Restangular', 'notification',
     '$stateParams',
     '$locale',
     '$location', '$window'];



// WEBPACK FOOTER //
// ./js/calendar/calendar.js